import { TableColumn } from './shared/table.constants';

export const MANAGER_ACTIONS_COLUMNS: TableColumn[] = [
  { id: 'actions', title: '', className: 'w-1/12' },
  { id: 'id', title: 'id' },
  { id: 'creation_date', title: 'creation_date' },
  { id: 'description', title: 'description' },
  { id: 'status', title: 'status', className: 'last:text-left' },
];
